import { Layout } from "@/components/layout/Layout";
import { SEO } from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

const ThankYou = () => {
  return (
    <Layout>
      <SEO
        title="Thank You | Bookkeeping Services South Africa"
        description="Your consultation request has been submitted. We'll contact you within 24 hours."
      />
      <section className="py-28 lg:py-36 section-light min-h-[60vh] flex items-center">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <div className="icon-container mx-auto mb-6 w-16 h-16">
              <CheckCircle2 className="w-8 h-8" />
            </div>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground mb-4">
              Thank You!
            </h1>
            <p className="text-muted-foreground text-lg mb-8">
              Your consultation request has been submitted successfully. Our team will contact you within 24 hours to schedule your free consultation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild className="btn-primary">
                <Link to="/">Back to Home</Link>
              </Button>
              <Button asChild variant="outline" className="btn-outline-primary">
                <Link to="/packages">View Our Packages</Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ThankYou;
